import img1 from '../../../assets/images/slide-1.jpg'
import img2 from '../../../assets/images/slide-2.jpg'
import img3 from '../../../assets/images/slide-3.jpg'
import img4 from '../../../assets/images/slide-4.jpg'
import img5 from '../../../assets/images/slide-5.jpg'

const slideImgs = [
    { image: img1 },
    { image: img2 }, 
    { image: img3 }, 
    { image: img4 }, 
    { image: img5 }
]

export default slideImgs